module.exports = [
  {
    text: "HRMS Onboarding",
    // logo: `${process.env.PUBLIC_URL}/assets/images/logos/hrms1.svg`,
    linkUrl: "https://hrmsonboarding.skilltree.org.in/",
  },
  {
    text: "Hubble Orion AMS",
    // logo: `${process.env.PUBLIC_URL}/assets/images/logos/hrms1.svg`, 
    linkUrl: "https://ams.skilltree.org.in/",
  },
  {
    logo: `${process.env.PUBLIC_URL}/assets/images/logos/people_strong.svg`,
    linkUrl: "https://auth.peoplestrong.com/",
  },
];